import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-913cf192"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-row align-items-center mb-4" }
const _hoisted_2 = {
  key: 0,
  class: "position-buttons text-primary p-2 mr-2"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-bars panel-drag-handle" }, null, -1))
const _hoisted_4 = {
  key: 1,
  class: "flex-grow-1"
}
const _hoisted_5 = { class: "m-0 flex-grow-1" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "d-flex flex-row" }
const _hoisted_8 = { class: "mb-0 mr-2" }
const _hoisted_9 = { class: "mb-4" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "d-flex flex-row-align-items-center" }
const _hoisted_12 = { class: "p-2 m-0 flex-grow-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_translate = _resolveComponent("translate")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Button = _resolveComponent("Button")!
  const _component_PanelEditorField = _resolveComponent("PanelEditorField")!
  const _component_PanelEditor = _resolveComponent("PanelEditor", true)!
  const _component_Draggable = _resolveComponent("Draggable")!
  const _component_Container = _resolveComponent("Container")!
  const _component_AnimatedInput = _resolveComponent("AnimatedInput")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    id: _ctx.id,
    class: _normalizeClass(["flat border p-4", { 'bg-light': _ctx.panel?.displayType?.toLowerCase() === 'section' }])
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!_ctx.disabled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("i", {
                class: "pi pi-caret-up",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('move-up'))),
                style: _normalizeStyle({ opacity: _ctx.canMoveUp ? '1' : '0' })
              }, null, 4),
              _hoisted_3,
              _createElementVNode("i", {
                class: "pi pi-caret-down",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('move-down'))),
                style: _normalizeStyle({ opacity: _ctx.canMoveDown ? '1' : '0' })
              }, null, 4)
            ]))
          : _createCommentVNode("", true),
        (_ctx.panel)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("h5", _hoisted_5, [
                _createTextVNode(_toDisplayString(_ctx.panel.ordinal ? _ctx.panel.ordinal + ' ' : '') + _toDisplayString(_ctx.labelTranslated) + " ", 1),
                (_ctx.panel.contentId)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, " (" + _toDisplayString(_ctx.panel.contentId) + ")", 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, [
                  _createVNode(_component_translate, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Abschnitt")
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_Checkbox, {
                  binary: "",
                  modelValue: _ctx.panel.repeatable,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.panel.repeatable) = $event)),
                  label: _ctx.i18n.$gettext('wiederholbar'),
                  name: "panel.repeatable",
                  disabled: _ctx.disabled
                }, null, 8, ["modelValue", "label", "disabled"])
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.disabled)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 2,
              class: "mr-2",
              icon: "pi pi-plus",
              label: _ctx.i18n.$gettext('Gruppe'),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openNewPanelDialog(_ctx.panel)))
            }, null, 8, ["label"]))
          : _createCommentVNode("", true),
        (!_ctx.disabled)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 3,
              class: "mr-2",
              icon: "pi pi-plus",
              label: _ctx.i18n.$gettext('Feld'),
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openNewFieldDialog(_ctx.panel)))
            }, null, 8, ["label"]))
          : _createCommentVNode("", true),
        (!_ctx.disabled)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 4,
              class: "mr-2",
              icon: "pi pi-pencil",
              onClick: _ctx.openPanelEditDialog
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (!_ctx.disabled && (!_ctx.isEuCopy || _ctx.panel.repeatable))
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 5,
              class: "mr-2",
              icon: "pi pi-copy",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('copy-content')))
            }))
          : _createCommentVNode("", true),
        (!_ctx.disabled && !_ctx.hasRequiredField)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 6,
              icon: "pi pi-trash",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('remove')))
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    content: _withCtx(() => [
      _createVNode(_component_Container, {
        orientation: "vertical",
        "group-name": "Fields",
        "drag-handle-selector": ".field-drag-handle,.panel-drag-handle",
        "drop-placeholder": { className:
                                 `drop-area`,
                               animationDuration: '200',
                               showOnTop: true },
        "drag-class": "shadow bg-color-lightgray\n            transition duration-100 ease-in\n            transform rotate-3 scale-110",
        "drop-class": "transition duration-100\n            ease-in z-50 transform\n            -rotate-2 scale-90",
        "get-child-payload": index => (_ctx.panel?.children || [])[index],
        onDrop: _cache[11] || (_cache[11] = (e) => _ctx.onFieldDrop(_ctx.panel, e))
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.panel?.children || []), (field, j) => {
            return (_openBlock(), _createBlock(_component_Draggable, { class: "mt-2" }, {
              default: _withCtx(() => [
                (field.contentType?.toLowerCase() === 'field')
                  ? (_openBlock(), _createBlock(_component_PanelEditorField, {
                      key: 0,
                      field: field,
                      index: j,
                      disabled: _ctx.disabled,
                      "is-eu-copy": _ctx.isEuCopy,
                      count: (_ctx.panel?.children || []).length,
                      onAddField: _cache[7] || (_cache[7] = f => _ctx.openNewFieldForCheckboxDialog(f)),
                      onStartEdit: _cache[8] || (_cache[8] = f => _ctx.openFieldEditDialog(f)),
                      onEditChoice: _cache[9] || (_cache[9] = choice => _ctx.openChoiceEditDialog(choice)),
                      onAddFieldForChoice: _cache[10] || (_cache[10] = choice => _ctx.openNewFieldForChioceDialog(choice)),
                      onCopyField: ($event: any) => (_ctx.panel?.children?.splice(j, 0, _ctx.copyPanel(field))),
                      onRemoveField: ($event: any) => (_ctx.panel?.children?.splice(j, 1)),
                      onMoveUp: ($event: any) => (_ctx.panel?.children?.splice(Math.max(j - 1, 0), 0, _ctx.panel?.children?.splice(j, 1)[0])),
                      onMoveDown: ($event: any) => (_ctx.panel?.children?.splice(Math.min(j + 1, _ctx.panel?.children?.length - 1), 0, _ctx.panel?.children?.splice(j, 1)[0]))
                    }, null, 8, ["field", "index", "disabled", "is-eu-copy", "count", "onCopyField", "onRemoveField", "onMoveUp", "onMoveDown"]))
                  : (field.contentType?.toLowerCase() === 'group')
                    ? (_openBlock(), _createBlock(_component_PanelEditor, {
                        key: 1,
                        panel: field,
                        id: (_ctx.id || '') + '-' + field.contentId + '-' + j,
                        disabled: _ctx.disabled,
                        "is-eu-copy": _ctx.isEuCopy,
                        "can-move-up": j > 0,
                        "can-move-down": j < (_ctx.panel?.children || []).length - 1,
                        onCopyContent: ($event: any) => (_ctx.panel?.children?.splice(j, 0, _ctx.copyPanel(field))),
                        onRemove: ($event: any) => (_ctx.panel?.children?.splice(j, 1)),
                        onMoveUp: ($event: any) => (_ctx.panel?.children?.splice(Math.max(j - 1, 0), 0, _ctx.panel?.children?.splice(j, 1)[0])),
                        onMoveDown: ($event: any) => (_ctx.panel?.children?.splice(Math.min(j + 1, _ctx.panel?.children?.length - 1), 0, _ctx.panel?.children?.splice(j, 1)[0]))
                      }, null, 8, ["panel", "id", "disabled", "is-eu-copy", "can-move-up", "can-move-down", "onCopyContent", "onRemove", "onMoveUp", "onMoveDown"]))
                    : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024))
          }), 256))
        ]),
        _: 1
      }, 8, ["get-child-payload"]),
      _createVNode(_component_Dialog, {
        header: _ctx.i18n.$gettext(_ctx.editedField ? 'Feld bearbeiten' : 'Feld hinzufügen'),
        visible: _ctx.showNewFieldDialog,
        "onUpdate:visible": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.showNewFieldDialog) = $event)),
        onHide: _ctx.resetDialogues,
        modal: ""
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            label: _ctx.i18n.$gettext('Abbrechen'),
            icon: "pi pi-times",
            class: "p-button-text",
            onClick: _ctx.resetDialogues
          }, null, 8, ["label", "onClick"]),
          _createVNode(_component_Button, {
            label: _ctx.i18n.$gettext('Speichern'),
            icon: "pi pi-check",
            autofocus: "",
            disabled: !_ctx.newFieldName || !!_ctx.newFieldChoiceName,
            onClick: _ctx.addOrSaveField
          }, null, 8, ["label", "disabled", "onClick"])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_AnimatedInput, {
            modelValue: _ctx.newFieldOrdinal,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.newFieldOrdinal) = $event)),
            label: _ctx.i18n.$gettext('Gliederungspunkt'),
            class: "mb-4"
          }, null, 8, ["modelValue", "label"]),
          _createVNode(_component_AnimatedInput, {
            modelValue: _ctx.newFieldName,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.newFieldName) = $event)),
            "auto-resize": "",
            label: _ctx.i18n.$gettext('Feld-Name'),
            class: "mb-4"
          }, null, 8, ["modelValue", "label"]),
          _createVNode(_component_AnimatedInput, {
            modelValue: _ctx.newFieldContentId,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.newFieldContentId) = $event)),
            "auto-resize": "",
            label: _ctx.i18n.$gettext('Content-ID'),
            class: "mb-4"
          }, null, 8, ["modelValue", "label"]),
          _createVNode(_component_Dropdown, {
            class: "mb-4",
            modelValue: _ctx.newFieldType,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.newFieldType) = $event)),
            options: _ctx.fieldTypeOptions,
            optionLabel: "name",
            optionValue: "type",
            label: _ctx.i18n.$gettext('Feld-Typ')
          }, null, 8, ["modelValue", "options", "label"]),
          _createElementVNode("div", _hoisted_9, [
            (![ 'CHECKBOX', 'RADIO' ].includes(_ctx.newFieldType || ''))
              ? (_openBlock(), _createBlock(_component_Checkbox, {
                  key: 0,
                  binary: "",
                  modelValue: _ctx.newFieldRequired,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.newFieldRequired) = $event)),
                  label: _ctx.i18n.$gettext('Feld ist erforderlich'),
                  name: "newFieldRequired",
                  class: "my-2"
                }, null, 8, ["modelValue", "label"]))
              : _createCommentVNode("", true),
            _createVNode(_component_Checkbox, {
              binary: "",
              modelValue: _ctx.newFieldAlwaysShow,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.newFieldAlwaysShow) = $event)),
              label: _ctx.i18n.$gettext('Auch anzeigen wenn leer'),
              name: "newFieldAlwaysShow",
              class: _normalizeClass(["my-2", { 'opacity-0': ![ 'CHECKBOX', 'RADIO' ].includes(_ctx.newFieldType || '') && _ctx.newFieldRequired }])
            }, null, 8, ["modelValue", "label", "class"])
          ]),
          ([ 'DROPDOWN', 'MULTICHECKBOX', 'COMBOBOX' ].includes(_ctx.newFieldType))
            ? (_openBlock(), _createElementBlock("form", {
                key: 0,
                class: "d-flex flex-row mb-4",
                onSubmit: _cache[19] || (_cache[19] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addOption && _ctx.addOption(...args)), ["prevent","stop"]))
              }, [
                _createVNode(_component_AnimatedInput, {
                  modelValue: _ctx.newFieldChoiceName,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.newFieldChoiceName) = $event)),
                  "auto-resize": "",
                  label: _ctx.i18n.$gettext('Auswahl-Option')
                }, null, 8, ["modelValue", "label"]),
                _createVNode(_component_Button, {
                  type: "submit",
                  icon: "pi pi-plus",
                  class: "ml-3",
                  disabled: !_ctx.newFieldChoiceName
                }, null, 8, ["disabled"])
              ], 32))
            : _createCommentVNode("", true),
          (_ctx.newFieldChoices)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.newFieldChoices || []), (choice, k) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("p", _hoisted_12, _toDisplayString(choice.name), 1),
                    _createVNode(_component_Button, {
                      class: "flat p-button-text",
                      icon: "pi pi-trash",
                      onClick: ($event: any) => (_ctx.newFieldChoices.splice(k, 1))
                    }, null, 8, ["onClick"])
                  ]))
                }), 256))
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_AnimatedInput, {
            modelValue: _ctx.newFieldDefaultStringValue,
            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.newFieldDefaultStringValue) = $event)),
            "auto-resize": "",
            label: _ctx.i18n.$gettext('Wert'),
            class: "mb-4"
          }, null, 8, ["modelValue", "label"])
        ]),
        _: 1
      }, 8, ["header", "visible", "onHide"]),
      _createVNode(_component_Dialog, {
        header: _ctx.i18n.$gettext(_ctx.editedPanel ? 'Gruppe bearbeiten' : 'Gruppe hinzufügen'),
        visible: _ctx.showNewPanelDialog,
        "onUpdate:visible": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.showNewPanelDialog) = $event)),
        onHide: _ctx.resetDialogues,
        modal: ""
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            label: _ctx.i18n.$gettext('Abbrechen'),
            icon: "pi pi-times",
            class: "p-button-text",
            onClick: _ctx.resetDialogues
          }, null, 8, ["label", "onClick"]),
          _createVNode(_component_Button, {
            label: _ctx.i18n.$gettext('Speichern'),
            icon: "pi pi-check",
            autofocus: "",
            disabled: !_ctx.newPanelName,
            onClick: _ctx.addOrSavePanel
          }, null, 8, ["label", "disabled", "onClick"])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_AnimatedInput, {
            modelValue: _ctx.newPanelOrdinal,
            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.newPanelOrdinal) = $event)),
            label: _ctx.i18n.$gettext('Gliederungspunkt'),
            class: "mb-4"
          }, null, 8, ["modelValue", "label"]),
          _createVNode(_component_AnimatedInput, {
            modelValue: _ctx.newPanelName,
            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.newPanelName) = $event)),
            "auto-resize": "",
            label: _ctx.i18n.$gettext('Gruppen-Name'),
            class: "mb-4"
          }, null, 8, ["modelValue", "label"]),
          _createVNode(_component_AnimatedInput, {
            modelValue: _ctx.newPanelContentId,
            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.newPanelContentId) = $event)),
            "auto-resize": "",
            label: _ctx.i18n.$gettext('Content-ID'),
            class: "mb-4"
          }, null, 8, ["modelValue", "label"])
        ]),
        _: 1
      }, 8, ["header", "visible", "onHide"]),
      _createVNode(_component_Dialog, {
        header: _ctx.i18n.$gettext('Option bearbeiten'),
        visible: _ctx.showEditChoiceDialog,
        "onUpdate:visible": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.showEditChoiceDialog) = $event)),
        onHide: _ctx.resetDialogues,
        modal: ""
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            label: _ctx.i18n.$gettext('Abbrechen'),
            icon: "pi pi-times",
            class: "p-button-text",
            onClick: _ctx.resetDialogues
          }, null, 8, ["label", "onClick"]),
          _createVNode(_component_Button, {
            label: _ctx.i18n.$gettext('Speichern'),
            icon: "pi pi-check",
            autofocus: "",
            disabled: !_ctx.editedChoiceOrPanelName,
            onClick: _ctx.acceptChoiceChanges
          }, null, 8, ["label", "disabled", "onClick"])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_AnimatedInput, {
            modelValue: _ctx.editedChoiceOrPanelName,
            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.editedChoiceOrPanelName) = $event)),
            "auto-resize": "",
            label: _ctx.i18n.$gettext('Text/Name der Option'),
            class: "mb-4"
          }, null, 8, ["modelValue", "label"]),
          _createVNode(_component_AnimatedInput, {
            modelValue: _ctx.editedChoiceContentId,
            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.editedChoiceContentId) = $event)),
            "auto-resize": "",
            label: _ctx.i18n.$gettext('Content-ID der Option'),
            class: "mb-4"
          }, null, 8, ["modelValue", "label"])
        ]),
        _: 1
      }, 8, ["header", "visible", "onHide"]),
      _createVNode(_component_Dialog, {
        header: _ctx.i18n.$gettext('Abschnitt bearbeiten'),
        visible: _ctx.showEditPanelDialog,
        "onUpdate:visible": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.showEditPanelDialog) = $event)),
        onHide: _ctx.resetDialogues,
        modal: ""
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            label: _ctx.i18n.$gettext('Abbrechen'),
            icon: "pi pi-times",
            class: "p-button-text",
            onClick: _ctx.resetDialogues
          }, null, 8, ["label", "onClick"]),
          _createVNode(_component_Button, {
            label: _ctx.i18n.$gettext('Speichern'),
            icon: "pi pi-check",
            autofocus: "",
            disabled: !_ctx.editedChoiceOrPanelName,
            onClick: _cache[32] || (_cache[32] = ($event: any) => {_ctx.editedPanel.label = _ctx.editedChoiceOrPanelName; _ctx.editedPanel.ordinal = _ctx.editedPanelOrdinal; _ctx.editedPanel.contentId = _ctx.editedPanelContentId; _ctx.resetDialogues()})
          }, null, 8, ["label", "disabled"])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_AnimatedInput, {
            modelValue: _ctx.editedPanelOrdinal,
            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.editedPanelOrdinal) = $event)),
            label: _ctx.i18n.$gettext('Gliederungspunkt'),
            class: "mb-4"
          }, null, 8, ["modelValue", "label"]),
          _createVNode(_component_AnimatedInput, {
            modelValue: _ctx.editedChoiceOrPanelName,
            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.editedChoiceOrPanelName) = $event)),
            "auto-resize": "",
            label: _ctx.i18n.$gettext('Abschnitt-Name'),
            class: "mb-4"
          }, null, 8, ["modelValue", "label"]),
          _createVNode(_component_AnimatedInput, {
            modelValue: _ctx.editedPanelContentId,
            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.editedPanelContentId) = $event)),
            "auto-resize": "",
            label: _ctx.i18n.$gettext('Content-ID'),
            class: "mb-4"
          }, null, 8, ["modelValue", "label"])
        ]),
        _: 1
      }, 8, ["header", "visible", "onHide"])
    ]),
    _: 1
  }, 8, ["id", "class"]))
}